<template>
  <div id="pageCadastroUsuario">
    <v-container grid-list-x2 fluid>
      <v-layout row wrap justify-center>
        <v-flex lg6 sm12 xs12>
          <v-card>
            <v-toolbar color="pink" dark flat dense cad>
              <v-toolbar-title v-if="this.id" class="subheading">Editar usuário</v-toolbar-title>
              <v-toolbar-title v-else class="subheading">Novo usuário</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="">
              <cadastro-form></cadastro-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import CadastroForm from "@/components/usuarios/cadastroUsuario"
export default {
  components: {
    CadastroForm
  },
  data: () => ({
    id: null
  }),
  computed: {
    form() {
      return {
        id: this.id
      }
    }
  },
  created() {
    if (this.$route && this.$route.params) {
      this.id = this.$route.params.id
    }
  }
}
</script>
